import { useState } from "react";
import Image from "components/Elements/Image/Image";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

const INBOX_ORDERS = [
  {
    title: "forms-control-title",
    description: "forms-control-description",
    icon: "forms-control-icon",
    image: "forms-control-img",
  },
  {
    title: "forms-notification-title",
    description: "forms-notification-description",
    icon: "forms-notification-icon",
    image: "forms-notification-img",
  },
  {
    title: "forms-tracker-title",
    description: "forms-tracker-description",
    icon: "forms-tracker-icon",
    image: "forms-tracker-img",
  },
];

const InboxSection = () => {
  const { desktopCondition } = useMediaQueries();
  const { getTextByKey, getHtmlByKey } = useContent();
  const [selectedText, setSelectedText] = useState(0);

  return (
    <div className="inbox-section">
      <h2>{getTextByKey("inbox-section-title")}</h2>
      {desktopCondition ? (
        <div className="content-section">
          <div className="text-section">
            {INBOX_ORDERS.map((item, index) => (
              <div
                key={index}
                className={`text-item ${
                  selectedText === index ? "selected" : ""
                }`}
                onClick={() => setSelectedText(index)}
              >
                <div className="text-item-header">
                  <Image
                    name={`embed-forms/${item.icon}`}
                    alt="icon"
                    className="text-icon"
                  />
                  <h3>{getTextByKey(item.title)}</h3>
                  <Icon name="arrow-down" alt="arrow" iconClass="arrow-icon" />
                </div>
                <div className="text-item-desciption">
                  <span>{getHtmlByKey(item.description)}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="image-section">
            <Image
              name={`embed-forms/${INBOX_ORDERS[selectedText].image}`}
              alt={INBOX_ORDERS[selectedText].title}
              ext="png"
            />
          </div>
        </div>
      ) : (
        <div className="content-section-mobile">
          {INBOX_ORDERS.map((item, index) => (
            <div key={index} className="control-item">
              <div className="text-item-header">
                <Image
                  name={`embed-forms/${item.icon}`}
                  alt="icon"
                  className="text-icon"
                />
                <h3>{getTextByKey(item.title)}</h3>
              </div>
              <div className="text-item-desciption">
                <span>{getHtmlByKey(item.description)}</span>
              </div>
              <div className="image-section">
                <Image
                  name={`embed-forms/${item.image}-mob`}
                  alt={item.title}
                  ext="png"
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InboxSection;
